import type { RankingRichText } from '../types';

export const richTextToPlainText = (text: string | RankingRichText): string =>
  typeof text === 'string' ? text : text.map((part) => (typeof part === 'string' ? part : part.text)).join('');
